import React from 'react'
import Styles from './styles.module.sass'

export function Error500(){

    return(
        <>
            <div className={Styles?.errorService500}>
                <div className={Styles?.iconSession}></div>
                <h1 className={Styles?.titleMessage}>¡Es cuestión de tiempo!</h1>
                <p className={Styles?.textMessage}>Estamos trabajando para mejorar tu experiencia, <strong>por favor inténtalo más tarde.</strong></p>

            </div>
        </>
    )
}